export default __webpack_public_path__ + "static/media/group.d09ba43e.svg";